// The site's Hindi / English interface text (navigation, headings, buttons,
// labels). Project names, descriptions and blog posts are the company's own
// words and are not translated. A key with no Hindi line shows the English.
export const TRANSLATIONS = {
  en: {
    nav_home: 'Home',
    nav_projects: 'Projects',
    nav_contact: 'Contact',
    nav_why: 'Why KeysGrove',
    nav_enquire: 'Enquire',
    nav_admin: 'Admin',
    nav_blog: 'Blog',
    nav_menu: 'Menu',

    hero_eyebrow: 'Noida · Gurugram · Yamuna Expressway',
    hero_title: 'Real estate along the corridors shaping the next NCR.',
    hero_sub: "KeysGrove curates RERA-registered residential, plot and ultra-luxury addresses across Noida, Gurugram and the Yamuna Expressway — including freehold YIDA plots near the upcoming airport and Film City.",
    hero_browse: 'Browse Projects',
    hero_talk: 'Talk to Us',

    stat_live_projects: 'Live Projects',
    stat_corridors: 'Corridors Covered',
    stat_ready: 'Ready to Move',
    stat_rera: 'RERA Registered',

    eyebrow_spotlight: 'Spotlight',
    eyebrow_browse_corridor: 'Browse by corridor',
    heading_find_stretch: 'Find your stretch of the NCR',
    eyebrow_listings: 'Current listings',
    heading_featured: 'Featured projects',
    view_all_projects: 'View all projects',

    chip_noida: 'Noida',
    chip_gurugram: 'Gurugram',
    chip_yamuna: 'Yamuna Expressway',
    chip_yida: 'YIDA Plots',
    chip_luxury: 'Ultra-Luxury',

    eyebrow_why_buy: 'Why buy through us',
    heading_why_buy: 'Why buy through KeysGrove',
    reason1_title: 'RERA-first listings',
    reason1_body: 'Every project on KeysGrove is published with its RERA registration number, verified before it goes live.',
    reason2_title: 'Corridor expertise',
    reason2_body: 'We track Noida, Gurugram and the Yamuna Expressway closely — including YIDA notifications and infrastructure timelines.',
    reason3_title: 'No brokerage games',
    reason3_body: 'Transparent pricing bands, unit types and possession dates — no bait-and-switch listings.',
    reason4_title: 'One enquiry, direct response',
    reason4_body: 'Your enquiry reaches our desk directly — no call-centre relay, no resale of your details.',

    eyebrow_get_in_touch: 'Get in touch',
    heading_tell_us: "Tell us what you're looking for",
    label_full_name: 'Full name*',
    label_phone: 'Phone*',
    label_email: 'Email',
    label_budget: 'Budget range',
    option_select: 'Select…',
    label_message: 'Message',
    placeholder_message: 'Tell us the corridor, project type or timeline you have in mind',
    submit_enquiry: 'Submit Enquiry',

    heading_all_listings: 'All listings',
    heading_projects_title: 'Projects across Noida, Gurugram & the Yamuna Expressway',
    projects_sub: 'Filter by corridor, project type or status to find a RERA-registered listing that matches your brief.',
    label_search: 'Search',
    placeholder_search: 'Project name, sector, locality…',
    label_corridor: 'Corridor',
    option_all_corridors: 'All corridors',
    label_project_type: 'Project type',
    option_all_types: 'All types',
    label_status: 'Status',
    option_any_status: 'Any status',
    apply_filters: 'Apply Filters',

    contact_eyebrow: 'Get in touch',
    contact_heading_prefix: 'Contact',

    blog_eyebrow: 'Insights',
    blog_heading: 'Market notes & insights',

    nav_privacy: 'Privacy',
    nav_terms: 'Terms',
  },
  hi: {
    nav_home: 'होम',
    nav_projects: 'प्रोजेक्ट्स',
    nav_contact: 'संपर्क करें',
    nav_why: 'KeysGrove क्यों',
    nav_enquire: 'पूछताछ',
    nav_admin: 'एडमिन',
    nav_blog: 'ब्लॉग',
    nav_menu: 'मेनू',

    hero_eyebrow: 'नोएडा · गुड़गांव · यमुना एक्सप्रेसवे',
    hero_title: 'एनसीआर के भविष्य को आकार देने वाले कॉरीडोर पर रियल एस्टेट।',
    hero_sub: 'KeysGrove नोएडा, गुड़गांव और यमुना एक्सप्रेसवे में RERA-पंजीकृत रेज़ीडेंशियल, प्लॉट और अल्ट्रा-लग्ज़री पते क्यूरेट करता है — आने वाले हवाई अड्डे और फिल्म सिटी के पास फ्रीहोल्ड YIDA प्लॉट सहित।',
    hero_browse: 'प्रोजेक्ट्स देखें',
    hero_talk: 'हमसे बात करें',

    stat_live_projects: 'लाइव प्रोजेक्ट्स',
    stat_corridors: 'कॉरीडोर कवर',
    stat_ready: 'रहने के लिए तैयार',
    stat_rera: 'RERA पंजीकृत',

    eyebrow_spotlight: 'स्पॉटलाइट',
    eyebrow_browse_corridor: 'कॉरीडोर के अनुसार देखें',
    heading_find_stretch: 'अपना NCR का हिस्सा खोजें',
    eyebrow_listings: 'वर्तमान सूचीबद्धताएं',
    heading_featured: 'विशेष प्रोजेक्ट्स',
    view_all_projects: 'सभी प्रोजेक्ट्स देखें',

    chip_noida: 'नोएडा',
    chip_gurugram: 'गुड़गांव',
    chip_yamuna: 'यमुना एक्सप्रेसवे',
    chip_yida: 'YIDA प्लॉट',
    chip_luxury: 'अल्ट्रा-लग्ज़री',

    eyebrow_why_buy: 'हमारे साथ खरीदें',
    heading_why_buy: 'KeysGrove के साथ खरीदें',
    reason1_title: 'RERA-प्रथम सूचीबद्धताएं',
    reason1_body: 'KeysGrove पर हर प्रोजेक्ट उसके RERA पंजीकरण नंबर के साथ प्रकाशित होता है, लाइव होने से पहले सत्यापित।',
    reason2_title: 'कॉरीडोर विशेषज्ञता',
    reason2_body: 'हम नोएडा, गुड़गांव और यमुना एक्सप्रेसवे पर बारीकी से नज़र रखते हैं।',
    reason3_title: 'कोई दलाली नहीं',
    reason3_body: 'पारदर्शी मूल्य स्तर, यूनिट प्रकार और कब्ज़ा तिथियां — कोई बेत-एंड-स्विच नहीं।',
    reason4_title: 'एक पूछताछ, सीधा जवाब',
    reason4_body: 'आपकी पूछताछ सीधे हमारे डेस्क तक पहुंचती है — कोई कॉल-सेंटर रिले नहीं।',

    eyebrow_get_in_touch: 'संपर्क करें',
    heading_tell_us: 'हमें बताएं आप क्या ढूंढ रहे हैं',
    label_full_name: 'पूरा नाम*',
    label_phone: 'फोन*',
    label_email: 'ईमेल',
    label_budget: 'बजट रेंज',
    option_select: 'चुनें…',
    label_message: 'संदेश',
    placeholder_message: 'हमें कॉरीडोर, प्रोजेक्ट प्रकार या समयसीमा बताएं',
    submit_enquiry: 'पूछताछ भेजें',

    heading_all_listings: 'सभी सूचीबद्धताएं',
    heading_projects_title: 'नोएडा, गुड़गांव और यमुना एक्सप्रेसवे के प्रोजेक्ट्स',
    projects_sub: 'अपनी ज़रूरत के अनुसार RERA-पंजीकृत सूची खोजने के लिए कॉरीडोर, प्रोजेक्ट प्रकार या स्थिति द्वारा फ़िल्टर करें।',
    label_search: 'खोजें',
    placeholder_search: 'प्रोजेक्ट का नाम, सेक्टर, इलाका…',
    label_corridor: 'कॉरीडोर',
    option_all_corridors: 'सभी कॉरीडोर',
    label_project_type: 'प्रोजेक्ट प्रकार',
    option_all_types: 'सभी प्रकार',
    label_status: 'स्थिति',
    option_any_status: 'कोई भी स्थिति',
    apply_filters: 'फ़िल्टर लगाएं',

    contact_eyebrow: 'संपर्क करें',
    contact_heading_prefix: 'संपर्क',

    blog_eyebrow: 'जानकारी',
    blog_heading: 'बाज़ार टिप्पणियां और जानकारी',

    nav_privacy: 'गोपनीयता',
    nav_terms: 'शर्तें',
  },
};
